export class InvalidDependencyTypeError extends Error {
    constructor() {
        super('Dependency type is incorrect.');
    }
}
